(() => {
  const init = root => {
    const promo = root.querySelector('[data-nb-klarna-promo]');
    if (!promo || promo.dataset.thresholdInitialized) return;
    promo.dataset.thresholdInitialized = 'true';
    const sync = () => {
      const selected = root.querySelector('[data-nb-variant]')?.selectedOptions[0];
      const raw = selected ? selected.dataset.klarnaPrice : promo.dataset.sellingPrice;
      const price = raw === undefined || raw === '' ? NaN : Number(raw);
      const limitedCurrency = promo.dataset.currency === 'GBP' || promo.dataset.currency === 'EUR';
      promo.hidden = promo.dataset.priceVisible !== 'true' || !Number.isFinite(price) || price < 0 || (limitedCurrency && price < 5000);
    };
    root.addEventListener('change', sync);
    sync();
  };
  const scan = () => document.querySelectorAll('[data-nb-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
